/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

/**
 * Сообщение об ошибке
 */
export interface ErrorMessage {
  /** @format date-time */
  timestamp?: string;

  /** @format int32 */
  status?: number;
  error?: string;
  path?: string;
}

/**
 * Ответ при проверке соответствия токена
 */
export interface TokenCheckResponse {
  /** @format uuid */
  clientId?: string;
}

/**
 * Запрос проверки принятия оферты
 */
export interface OfferResponse {
  /** @format uuid */
  clientId?: string;
  isOfferAgreed?: boolean;
}

/**
 * Универсальный ответ со значением clientId
 */
export interface CommonResponse {
  /**
   * Идентификатор клиента / организации
   * @format uuid
   */
  clientId?: string;
}

/**
 * Запрос кода с передачей токена
 */
export interface CodeRequest {
  token?: string;
}

/**
 * Ответ с кодом и ИНН
 */
export interface CodeResponse {
  code?: string;
  inn?: string;
}

import { HttpClient } from "../../client";
import { ContentType, RequestParams } from "../../client/types";

/**
 * @title Микросервис owb-ms-prd-subsc-sites-constr
 * @version 1.0
 * @license Все права защищены ООО РСХБ-ИНТЕХ
 * @baseUrl https://owb-ms-prd-subsc-sites-constr.ndbo.dev.rshbdev.ru
 * @contact https://sdlc.go.rshbank.ru/jira/projects/OB_SAAS <info@rshbintech.ru> (https://sdlc.go.rshbank.ru/confluence/pages/viewpage.action?pageId=196385940)
 */
export class Api<
  SecurityDataType extends unknown
> extends HttpClient<SecurityDataType> {
  api = {
    /**
     * No description
     *
     * @tags Контроллер токена
     * @name CheckToken
     * @summary Проверка соответствия токена для использования сервисов подписок
     * @request POST:/api/sites-constr/external/v1/shared/token/check
     * @secure
     */
    checkToken: (params: RequestParams = {}) =>
      this.request<TokenCheckResponse, ErrorMessage>({
        path: `/api/sites-constr/external/v1/shared/token/check`,
        method: "POST",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Интеграционный контроллер
     * @name CheckOfferAndRights
     * @summary Контроллер для проверки принятия оферты и прав доступа
     * @request POST:/api/sites-constr/external/v1/rights/check
     * @secure
     */
    checkOfferAndRights: (params: RequestParams = {}) =>
      this.request<OfferResponse, ErrorMessage>({
        path: `/api/sites-constr/external/v1/rights/check`,
        method: "POST",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Интеграционный контроллер
     * @name AcceptOffer
     * @summary Контроллер для акцепта оферты
     * @request POST:/api/sites-constr/external/v1/offer/accept
     * @secure
     */
    acceptOffer: (params: RequestParams = {}) =>
      this.request<CommonResponse, ErrorMessage>({
        path: `/api/sites-constr/external/v1/offer/accept`,
        method: "POST",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Интеграционный контроллер
     * @name GenerateExchangeCode
     * @summary Контроллер для генерация кода доступа
     * @request POST:/api/sites-constr/external/v1/exchange/code/generate
     * @secure
     */
    generateExchangeCode: (data: CodeRequest, params: RequestParams = {}) =>
      this.request<CodeResponse, ErrorMessage>({
        path: `/api/sites-constr/external/v1/exchange/code/generate`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
  };
}

export const api = new Api();
